import { Cell, flexRender } from "@tanstack/react-table";
import classNames from "classnames";
import { CSSProperties, ReactNode } from "react";

import { TableData } from "../table";
import css from "../table.module.scss";

export type TableCellProps<TABLE_DATA extends TableData> = {
  cell: Cell<TABLE_DATA, unknown>;
  compact?: boolean;
  displayGrid?: boolean;
  disabled?: boolean;
  hideDistantRows?: boolean;
  rowIndex?: number;
  colIndex?: number;
  className?: string;
  style?: CSSProperties;
  // Used by the interactive table layer to inject the fill-handle widget.
  fillHandle?: ReactNode;
  isLastColumn?: boolean;
};

export const TableCell = <TABLE_DATA extends TableData>({
  cell,
  compact,
  displayGrid,
  hideDistantRows,
  rowIndex,
  colIndex,
  className,
  style,
  fillHandle
}: TableCellProps<TABLE_DATA>) => {
  const { align, sticky, cellClassName, getRowSpan } = cell.column.columnDef.meta || {};
  const rowSpan = getRowSpan && rowIndex !== undefined ? getRowSpan(rowIndex) : undefined;

  return (
    <td
      className={classNames(cellClassName, className, {
        [css.compactCell]: compact,
        [css.alignRight]: align === "right",
        [css.sticky]: sticky,
        [css.displayGrid]: displayGrid,
        [css.visibleContent]: hideDistantRows
      })}
      style={{
        width: cell.column.getSize() !== 0 ? cell.column.getSize() : undefined,
        ...style
      }}
      data-row-index={rowIndex}
      data-col-index={colIndex}
      rowSpan={rowSpan}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
      {fillHandle}
    </td>
  );
};
